module.exports = __webpack_public_path__ + "img/germany-flag.58cdc5f4.png";